const CONSTANTS = {
  LOGS: {
    INFO: 'log-info',
  } as const,
  ROUTES: {
    GUEST_HOME: '/',
    MEMBER_HOME: '/dashboard',
    ADMIN_HOME: '/admin/user-list',
  } as const,
  MAX_STOCK_CHOICE: 20,
  MAX_PORTFOLIO: 20,
  TOURS: {
    dashboard: ['DASHBOARD_LANDING_TOUR'],
    stockChoiceAddForm: ['FORM_TOUR'],
    account: ['ACCOUNT_TOUR'],
  } as const,
  // Reference: https://www.dsebd.org/latest_share_price_scroll_l.php
  // TODO: get updated trading code list from backend

  TRADING_CODES: [
    '1JANATAMF',
    '1STPRIMFMF',
    'AAMRANET',
    'AAMRATECH',
    'ABB1STMF',
    'ABBANK',
    'ACFL',
    'ACI',
    'ACIFORMULA',
    'ACMELAB',
    'ACMEPL',
    'ACTIVEFINE',
    'ADNTEL',
    'ADVENT',
    'AFCAGRO',
    'AFTABAUTO',
    'AGNISYSL',
    'AGRANINS',
    'AIBL1STIMF',
    'AIL',
    'ALARABANK',
    'AL-HAJTEX',
    'ALIF',
    'ALLTEX',
    'AMANFEED',
    'AMBEEPHA',
    'AMCL(PRAN)',
    'ANLIMAYARN',
    'ANWARGALV',
    'AOL',
    'APEXFOODS',
    'APEXFOOT',
    'APEXSPINN',
    'APEXTANRY',
    'APOLOISPAT',
    'ARAMIT',
    'ARAMITCEM',
    'ARGONDENIM',
    'ASIAINS',
    'ASIAPACINS',
    'ATCSLGF',
    'ATLASBANG',
    'AZIZPIPES',
    'BANGAS',
    'BANKASIA',
    'BARKAPOWER',
    'BATASHOE',
    'BATBC',
    'BAYLEASING',
    'BBS',
    'BBSCABLES',
    'BDAUTOCA',
    'BDCOM',
    'BDFINANCE',
    'BDLAMPS',
    'BDSERVICE',
    'BDTHAI',
    'BDTHAIFOOD',
    'BDWELDING',
    'BEACHHATCH',
    'BEACONPHAR',
    'BENGALWTL',
    'BERGERPBL',
    'BEXIMCO',
    'BGIC',
    'BIFC',
    'BNICL',
    'BPML',
    'BPPL',
    'BRACBANK',
    'BSC',
    'BSCCL',
    'BSRMLTD',
    'BSRMSTEEL',
    'BXPHARMA',
    'BXSYNTH',
    'CAPMBDBLMF',
    'CAPMIBBLMF',
    'CENTRALINS',
    'CENTRALPHL',
    'CITYBANK',
    'CITYGENINS',
    'CNATEX',
    'CONFIDCEM',
    'CONTININS',
    'COPPERTECH',
    'CROWNCEMNT',
    'CRYSTALINS',
    'CVOPRL',
    'DACCADYE',
    'DAFODILCOM',
    'DBH',
    'DBH1STMF',
    'DELTALIFE',
    'DELTASPINN',
    'DESCO',
    'DESHBANDHU',
    'DGIC',
    'DHAKABANK',
    'DHAKAINS',
    'DOMINAGE',
    'DOREENPWR',
    'DSHGARME',
    'DSSL',
    'DULAMIACOT',
    'DUTCHBANGL',
    'EASTERNINS',
    'EASTLAND',
    'EASTRNLUB',
    'EBL',
    'EBL1STMF',
    'EBLNRBMF',
    'ECABLES',
    'EGEN',
    'EHL',
    'EIL',
    'EMERALDOIL',
    'ENVOYTEX',
    'EPGL',
    'ESQUIRENIT',
    'ETL',
    'EXIM1STMF',
    'EXIMBANK',
    'FAMILYTEX',
    'FARCHEM',
    'FAREASTFIN',
    'FAREASTLIF',
    'FASFIN',
    'FBFIF',
    'FEDERALINS',
    'FEKDIL',
    'FINEFOODS',
    'FIRSTFIN',
    'FIRSTSBANK',
    'FORTUNE',
    'FUWANGCER',
    'FUWANGFOOD',
    'GBBPOWER',
    'GEMINISEA',
    'GENEXIL',
    'GENNEXT',
    'GHAIL',
    'GHCL',
    'GLOBALINS',
    'GOLDENSON',
    'GP',
    'GPHISPAT',
    'GQBALLPEN',
    'GRAMEENS2',
    'GREENDELMF',
    'GREENDELT',
    'GSPFINANCE',
    'HAKKANIPUL',
    'HEIDELBCEM',
    'HFL',
    'HRTEX',
    'HWAWELLTEX',
    'IBNSINA',
    'IBP',
    'ICB',
    'ICB3RDNRB',
    'ICBAGRANI1',
    'ICBAMCL2ND',
    'ICBEPMF1S1',
    'ICBIBANK',
    'ICBSONALI1',
    'IDLC',
    'IFADAUTOS',
    'IFIC',
    'IFIC1STMF',
    'IFILISLMF1',
    'ILFSL',
    'IMAMBUTTON',
    'INDEXAGRO',
    'INTECH',
    'INTRACO',
    'IPDC',
    'ISLAMIBANK',
    'ISLAMICFIN',
    'ISLAMIINS',
    'ISNLTD',
    'ITC',
    'JAMUNABANK',
    'JAMUNAOIL',
    'JANATAINS',
    'JHRML',
    'JMISMDL',
    'JUTESPINN',
    'KARNAPHULI',
    'KAY&QUE',
    'KBPPWBIL',
    'KDSALTD',
    'KEYACOSMET',
    'KOHINOOR',
    'KPCL',
    'KPPL',
    'KTL',
    'LANKABAFIN',
    'LEGACYFOOT',
    'LHBL',
    'LIBRAINFU',
    'LINDEBD',
    'LOVELLO',
    'LRBDL',
    'LRGLOBMF1',
    'MAKSONSPIN',
    'MALEKSPIN',
    'MARICO',
    'MATINSPINN',
    'MBL1STMF',
    'MEGCONMILK',
    'MEGHNACEM',
    'MEGHNAINS',
    'MEGHNALIFE',
    'MEGHNAPET',
    'MERCANBANK',
    'MERCINS',
    'METROSPIN',
    'MHSML',
    'MIDASFIN',
    'MIRACLEIND',
    'MIRAKHTER',
    'MITHUNKNIT',
    'MJLBD',
    'MLDYEING',
    'MONNOAGML',
    'MONNOCERA',
    'MONNOFABR',
    'MONOSPOOL',
    'MPETROLEUM',
    'MTB',
    'NAHEEACP',
    'NATLIFEINS',
    'NAVANACNG',
    'NBL',
    'NCCBANK',
    'NCCBLMF1',
    'NEWLINE',
    'NFML',
    'NHFIL',
    'NITOLINS',
    'NLI1STMF',
    'NORTHERN',
    'NORTHRNINS',
    'NPOLYMER',
    'NRBCBANK',
    'NTC',
    'NTLTUBES',
    'NURANI',
    'OAL',
    'OIMEX',
    'OLYMPIC',
    'ONEBANKLTD',
    'ORIONINFU',
    'ORIONPHARM',
    'PADMALIFE',
    'PADMAOIL',
    'PAPERPROC',
    'PARAMOUNT',
    'PDL',
    'PENINSULA',
    'PEOPLESINS',
    'PF1STMF',
    'PHARMAID',
    'PHENIXINS',
    'PHOENIXFIN',
    'PHPMF1',
    'PIONEERINS',
    'PLFSL',
    'POPULAR1MF',
    'POPULARLIF',
    'POWERGRID',
    'PRAGATIINS',
    'PRAGATILIF',
    'PREMIERBAN',
    'PREMIERCEM',
    'PREMIERLEA',
    'PRIME1ICBA',
    'PRIMEBANK',
    'PRIMEFIN',
    'PRIMEINSUR',
    'PRIMELIFE',
    'PRIMETEX',
    'PROGRESLIF',
    'PROVATIINS',
    'PTL',
    'PUBALIBANK',
    'PURABIGEN',
    'QUASEMIND',
    'QUEENSOUTH',
    'RAHIMAFOOD',
    'RAHIMTEXT',
    'RAKCERAMIC',
    'RANFOUNDRY',
    'RDFOOD',
    'RECKITTBEN',
    'REGENTTEX',
    'RELIANCE1',
    'RELIANCINS',
    'RENATA',
    'RENWICKJA',
    'REPUBLIC',
    'RINGSHINE',
    'RNSPIN',
    'ROBI',
    'RSRMSTEEL',
    'RUNNERAUTO',
    'RUPALIBANK',
    'RUPALIINS',
    'RUPALILIFE',
    'SAFKOSPINN',
    'SAIFPOWER',
    'SAIHAMCOT',
    'SAIHAMTEX',
    'SALAMCRST',
    'SALVOCHEM',
    'SAMATALETH',
    'SAMORITA',
    'SANDHANINS',
    'SAPORTL',
    'SAVAREFR',
    'SBACBANK',
    'SEAPEARL',
    'SEMLFBSLGF',
    'SEMLIBBLSF',
    'SEMLLECMF',
    'SHAHJABANK',
    'SHASHADNIM',
    'SHEPHERD',
    'SHURWID',
    'SHYAMPSUG',
    'SIBL',
    'SILCOPHL',
    'SILVAPHL',
    'SIMTEX',
    'SINGERBD',
    'SINOBANGLA',
    'SKICL',
    'SKTRIMS',
    'SONALIANSH',
    'SONALILIFE',
    'SONALIPAPR',
    'SONARBAINS',
    'SONARGAON',
    'SOUTHEASTB',
    'SPCERAMICS',
    'SPCL',
    'SQUARETEXT',
    'SQURPHARMA',
    'SSSTEEL',
    'STANCERAM',
    'STANDARINS',
    'STANDBANKL',
    'STYLECRAFT',
    'SUMITPOWER',
    'SUNLIFEINS',
    'TAKAFULINS',
    'TALLUSPIN',
    'TAMIJTEX',
    'TITASGAS',
    'TOSRIFA',
    'TRUSTB1MF',
    'TRUSTBANK',
    'TUNGHAI',
    'UCB',
    'UNILEVERCL',
    'UNIONBANK',
    'UNIONCAP',
    'UNIONINS',
    'UNIQUEHRL',
    'UNITEDFIN',
    'UNITEDINS',
    'UPGDCL',
    'USMANIAGL',
    'UTTARABANK',
    'UTTARAFIN',
    'VAMLBDMF1',
    'VAMLRBBF',
    'VFSTDL',
    'WALTONHIL',
    'WATACHEM',
    'WMSHIPYARD',
    'YPL',
    'ZAHEENSPIN',
    'ZAHINTEX',
    'ZEALBANGLA',
  ] as string[],
} as const;

export default CONSTANTS;
